import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '../../shared/skeleton/skeleton.component';

/** Loading placeholder shaped like a focus offering/knowledge form (stepper + fields). */
@Component({
  selector: 'inexp-form-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './form-skeleton.component.html',
  styleUrl: './form-skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 'aria-busy': 'true', 'aria-label': 'Loading form' },
})
export class FormSkeletonComponent {
  readonly steps = Array.from({ length: 6 });
  readonly fields = Array.from({ length: 6 });
}
